import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteSystemLogs} from '@/modules/system-logs/api'
import {SystemLogsFiltersGroup} from '@/modules/system-logs/components/system-logs-filters-group'
import {SystemLogsTable} from '@/modules/system-logs/components/system-logs-table'
import {SystemLogsSearchSchema} from '@/modules/system-logs/schemas'
import {Box, Text, VStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/system-logs/')({
  beforeLoad: requirePermission('logs.view'),
  component: SystemLogsPage,
  validateSearch: SystemLogsSearchSchema,
})

const LIMIT = 50

function SystemLogsPage() {
  const {t} = useTranslate('common')
  const search = Route.useSearch()
  const [sort] = search.sort

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = useGetInfiniteSystemLogs({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'performedAt',
    },
    multiFilters: search.multiFilters,
    filters: {name: search?.filters?.search},
  })

  return (
    <>
      <Box>
        <VStack align="stretch">
          <VStack paddingY={8} gap={8} align={'start'}>
            <VStack gap={2} align={'start'}>
              <Text fontWeight={'bold'} fontSize={'3xl'} fontFamily={'heading'}>
                {t('system_history_title')}
              </Text>
              <Text fontWeight={'normal'} fontSize={'md'} color={'fg.muted'}>
                {t('system_history_description')}
              </Text>
            </VStack>
            <SystemLogsFiltersGroup />
          </VStack>
        </VStack>
      </Box>

      <SystemLogsTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{}}
        hideBorder
      />
    </>
  )
}
